import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

/**
 * 收货单列表
 * @param {Object} params
 */
export const getPickingList = params => axios({
  url: `${commonPath}picking/list`,
  method: 'post',
  data: params
})

// 收货单-导出
export const exportPickingOrder = params => axios({
  url: `${commonPath}picking/order/export`,
  responseType: "blob",
  method: 'post',
  data: params
})

/**
 * 收货项列表
 * @param {Object} params
 */
export const getPickingLineList = params => axios({
  url: `${commonPath}picking_line/list`,
  method: 'post',
  data: params
})

// 导出收货项
export const exportPickingLineList = params => axios({
  url: `${commonPath}picking_line/export`,
  method: 'post',
  data: params,
  responseType: 'blob'
})

/**
 * 收货单类型列表
 */
export const getPickingTypeList = () => axios({
  url: `${commonPath}picking/type/list`,
  method: 'get'
})

/**
 * 拣项
 * @param {Object} params
 */
export const pickingUpItems = params => axios({
  url: `${commonPath}picking_line/pick_up_items`,
  method: 'post',
  data: params
})

/**
 * 收货单详情
 * @param {String} id
 */
export const getPickingInfo = id => axios({
  url: `${commonPath}picking/detail/${id}`,
  method: 'get'
})

/**
 * 收货项详情
 * @param {String} id
 */
export const getPickingLineInfo = id => axios({
  url: `${commonPath}picking_line/detail/${id}`,
  method: 'get'
})

/**
 * 收货单编辑
 * @param {Object} params
 */
export const editPicking = params => axios({
  url: `${commonPath}picking`,
  method: 'put',
  data: params
})

/**
 * 收货项编辑
 * @param {Object} params
 */
export const editPickingLine = params => axios({
  url: `${commonPath}picking_line`,
  method: 'put',
  data: params
})

/**
 * 收货单-箱单
 * @param {Object} params
 */
export const getPackingList = params => axios({
  url: `${commonPath}picking/packing_list/list`,
  method: 'post',
  data: params
})

/**
 * 收货单-箱单新增
 * @param {Object} params
 */
export const addPackingList = params => axios({
  url: `${commonPath}picking/packing_list`,
  method: 'post',
  data: params
})

/**
 * 收货单-箱单编辑
 * @param {Object} params
 */
export const editPackingList = params => axios({
  url: `${commonPath}picking/packing_list`,
  method: 'put',
  data: params
})

/**
 * 收货单-关单详情 transport.js
 */

/**
 * 收货单-关单编辑 transport.js
 */

/**
 * 运单详情 transport.js
 */

/**
 * 运单编辑 transport.js
 */

/**
 * 收货单-订单
 * @param {String} params
 */
export const getPickingOrder = params => axios({
  url: `${commonPath}picking/order/list`,
  method: 'post',
  data: params
})

/**
 * 收货单-联系人
 * @param {Object} params
 */
export const getPickingContacts = params => axios({
  url: `${commonPath}picking/contacts`,
  method: 'post',
  data: params
})

/**
 * 收货项-入库项
 * @param {Object} params
 */
export const getStorageList = params => axios({
  url: `${commonPath}picking_line/storage_list`,
  method: 'post',
  data: params
})

/**
 * 收货项-品检项 quality.js
 */

/**
 * 收货项-品检项编辑
 * @param {Object} params
 */
export const editQcTest = params => axios({
  url: `${commonPath}qc_test`,
  method: 'put',
  data: params
})

/**
 * 收货项-导出品检项
 * @param {Object} params
 */
export const exportQcTestList = params => axios({
  url: `${commonPath}qc_test/export`,
  method: 'post',
  data: params,
  responseType: 'blob'
})

/**
 * 收货项-箱单项
 * @param {Object} params
 */
export const getPackingItemList = params => axios({
  url: `${commonPath}packing_list_item/list`,
  method: 'post',
  data: params
})

/**
 * 收货单-箱单项新增
 * @param {Object} params
 */
export const addPackingListItem = params => axios({
  url: `${commonPath}packing_list_item`,
  method: 'post',
  data: params
})

/**
 * 收货单-箱单项编辑
 * @param {Object} params
 */
export const editPackingListItem = params => axios({
  url: `${commonPath}packing_list_item`,
  method: 'put',
  data: params
})

/**
 * 收货单-关单项详情
 * @param {String} id
 */
export const getTariffLine = id => axios({
  url: `${commonPath}picking_line/tariff_line_detail/${id}`,
  method: 'get'
})

/**
 * 收货单-关单项编辑 transport.js
 */

/**
 * 收货项-订单项
 * @param {Object} params
 */
export const getPackingLineOrder = params => axios({
  url: `${commonPath}picking_line/orderlist_line_list`,
  method: 'post',
  data: params
})

/**
 * 收货项-联系人
 * @param {Object} params
 */
export const getPackingLineContacts = params => axios({
  url: `${commonPath}picking_line/contact_list`,
  method: 'post',
  data: params
})

/**
 * 收货项-入库项拆分
 * @param {Object} params
 */
export const setStorageSplit = params => axios({
  url: `${commonPath}picking_line/storage_list/split`,
  method: 'post',
  data: params
})

// 收货单-打印
export const pickingPrint = id => axios({
  url: `${commonPath}picking/print/${id}`,
  method: 'get'
})

// 收货项-标签打印
export const pickingLinePrint = id => axios({
  url: `${commonPath}picking_line/print/${id}`,
  method: 'get'
})

// 导出收货项
export const autoReceive = params => axios({
  url: `${commonPath}picking_line/auto_receive`,
  method: 'post',
  data: params
})
